import Select2 from "select2";

const select2 = $(document).ready(function () {
    $(".select2").select2();
});

export { select2 as default };
